import "./otel";

export async function track(data) {
  const internal = await import(
    /* webpackChunkName: "track.internal" */
    "./internal"
  );
  internal.track(data);

  const ga = await import(
    /* webpackChunkName: "track.ga" */
    "./ga"
  );

  if (window.process.env.GA_ID) {
    ga.track(data, window.process.env.GA_ID);
  }
}
